import React from 'react';
import { motion } from 'framer-motion';

const articlesData = [
    {
        id: 1,
        title: "AI agents in cloud environments—security essentials",
        date: "May 07, 2026",
        image: "/assets/news/img1.png",
        link: "#"
    },
    {
        id: 2,
        title: "AI agents in cloud environments—security essentials",
        date: "May 07, 2026",
        image: "/assets/news/img2.png",
        link: "#"
    }
];

const RelatedArticlesSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-[#F1F1F1] font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 md:grid-cols-2 gap-[32px] md:gap-[40px] lg:gap-[60px]"
                >
                    {articlesData.map((article) => (
                        <motion.div
                            key={article.id}
                            variants={fadeUpVariant}
                            className="group flex flex-col h-full cursor-pointer"
                        >
                            <div className="w-full overflow-hidden mb-[16px] md:mb-[24px] shadow-sm rounded-sm">
                                <img
                                    src={article.image}
                                    alt={article.title}
                                    className="w-full h-auto aspect-[16/10] sm:aspect-[16/8] object-cover transition-transform duration-700 ease-in-out md:group-hover:scale-105"
                                />
                            </div>

                            <h3 className="text-[16px] md:text-[20px] font-sora font-[600] text-[#01386A] leading-[1.3] mb-[24px] md:mb-[40px] transition-colors duration-300">
                                {article.title}
                            </h3>

                            <div className="mt-auto flex justify-between items-center w-full pb-[10px]">
                                <a
                                    href={article.link}
                                    className="inline-flex items-center text-[14px] md:text-[16px] font-[600] text-[#01386A] transition-colors duration-300"
                                >
                                    <span className="border-b-[1.5px] border-[#01386A] pb-[2px] group-hover:border-[#F97316] transition-colors duration-300">
                                        Read More
                                    </span>
                                    <span className="ml-2 text-[#F97316] text-[16px] font-bold">&gt;</span>
                                </a>

                                <span className="text-[#F97316] text-[14px] md:text-[16px] font-[500] font-graphik tracking-wide">
                                    {article.date}
                                </span>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default RelatedArticlesSection;